import { type AxiosInstance, HttpStatusCode, isAxiosError } from "axios";
import { SendToTrackingService } from "@/api/handlers/errors";

interface UpdatePlotRequestDetailsRequest {
  remarks: string;
}

interface UpdatePlotRequestDetailsResponse {
  id: number;
  remarks: string;
  updatedAt: string;
}

/**
 * プロット詳細の備考を更新するAPI
 * @param {AxiosInstance} apiClient - axios
 * @param {number} detailId - 更新対象のプロット詳細ID
 * @param {UpdatePlotRequestDetailsRequest} data - 更新データ
 * @returns {Promise<UpdatePlotRequestDetailsResponse | undefined>}
 */
export const updatePlotRequestDetailsAPI = async (
  apiClient: AxiosInstance,
  detailId: number,
  data: UpdatePlotRequestDetailsRequest
): Promise<UpdatePlotRequestDetailsResponse | undefined> => {
  try {
    const response = await apiClient.put<UpdatePlotRequestDetailsResponse>(
      `/map/plot-request-details/${detailId}`,
      data
    );

    return response.status === HttpStatusCode.Ok ? response.data : undefined;
  } catch (error) {
    if (
      isAxiosError(error) &&
      (error.response?.status ?? HttpStatusCode.InternalServerError) >=
        HttpStatusCode.InternalServerError
    ) {
      SendToTrackingService(error);
    }
    throw error;
  }
};
